module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "content-map",
    attrs: {
      "modifier": "bg-transparent"
    },
    on: {
      "show": _vm.show,
      "hide": _vm.hide
    }
  }, [_c('div', {
    staticClass: "background"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/t_workstyle_concierge.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.currentContent === 1) ? _c('img', {
    key: "image-1",
    staticClass: "fade-contents",
    attrs: {
      "src": require("@/assets/images/t_workstyle_concierge-1.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentContent === 2) ? _c('img', {
    key: "image-2",
    staticClass: "fade-contents",
    attrs: {
      "src": require("@/assets/images/t_workstyle_concierge-2.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentContent === 3) ? _c('img', {
    key: "image-3",
    staticClass: "fade-contents",
    attrs: {
      "src": require("@/assets/images/t_workstyle_concierge-3.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentContent === 4) ? _c('img', {
    key: "image-4",
    staticClass: "fade-contents",
    attrs: {
      "src": require("@/assets/images/t_workstyle_concierge-4.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link",
    on: {
      "click": _vm.goToMap
    }
  }, [_vm._v("体験してみる")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cd9703a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/contents/t_workstyle_concierge.vue
// module id = 841
// module chunks = 0